export default {"src":"/_next/static/media/logo-kyobo.f43e72d2.svg","height":120,"width":202,"blurWidth":0,"blurHeight":0};